import customFetch from '../customFetch';

const API_URL = process.env.VUE_APP_MACHETE_NOTIFICATIONS_API_URL;

export default {
  async sendSms(companyId, data) {
    const response = await customFetch(`${API_URL}/send-message`, {
      method: 'POST',
      params: { companyId },
      body: JSON.stringify(data),
      errors: [
        { code: 500, message: 'Hubo un error al enviar sms' },
      ],
    });
    const { payload } = await response.json();
    return payload;
  },
};
